import React from "react";
import ReactDOM from "react-dom/client";

import "@mui/material/styles/styled"; // Initialise styled function as per: https://github.com/vitejs/vite/issues/12423#issuecomment-2080351394
import "./i18n/i18n";
import "./index.css";
import { App } from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
